module.exports = __webpack_public_path__ + "img/1.2e6e57c0.webp";